module.exports = __webpack_public_path__ + "img/elementheights_jaka.0147f645.png";